import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "adoption-search-course-selection",
  class AdoptionSearchCourseSelection extends WYATTElement {
    constructor() {
      super();

      this.sectionData = [];
    }

    get adoptionSearchCoursesInstance() {
      const parentElement = this.closest(".adoption-search");
      return parentElement.querySelector("adoption-search-courses");
    }

    get templates() {
      return {
        courseSelection: document.getElementById(
          "adoption-search-course-selection"
        ).content,
        courseSelectionEntry: document.getElementById(
          "adoption-search-course-selection-entry"
        ).content,
      };
    }

    get isCourseSelectionTemplateAppended() {
      return this.querySelector(".adoption-search__course-selection-container");
    }

    get courseSelectionList() {
      return this.querySelector(".adoption-search__course-selection-list");
    }

    get courseSelectionEntries() {
      return this.querySelectorAll(".adoption-search__course-selection-entry");
    }

    get courseSelectionForm() {
      return this.querySelector("form");
    }

    connectedCallback() {
      this.subscribe(
        WYATT.config.pubsub.events.adoptionSearchCoursesFormChange,
        this.handleAdoptionSearchCoursesFormChange.bind(this)
      );
    }

    handleAdoptionSearchCoursesFormChange(sectionData = []) {
      if (sectionData.length === 0) {
        return this.removeContainer();
      }

      this.sectionData = sectionData;

      if (!this.isCourseSelectionTemplateAppended) {
        this.appendContainer();
      }

      return this.appendEntries();
    }

    appendContainer() {
      this.appendChild(this.templates.courseSelection.cloneNode(true));
    }

    removeContainer() {
      this.courseSelectionForm.remove();
    }

    removeEntries() {
      this.courseSelectionEntries.forEach((entry) => {
        entry.remove();
      });
    }

    appendEntries() {
      this.removeEntries();

      this.sectionData.forEach((section) => {
        const entry = this.buildEntry(section);
        this.courseSelectionList.appendChild(entry);
      });
    }

    buildEntry(section) {
      const entryTemplate = this.templates.courseSelectionEntry.cloneNode(true);

      entryTemplate.querySelector("[data-course-id]").value = section.id;
      entryTemplate.querySelector("[data-course-button-text]").textContent =
        section.classNbr;

      entryTemplate
        .querySelector("[data-course-button]")
        .addEventListener("click", (event) => {
          event.preventDefault();
          this.adoptionSearchCoursesInstance.removeSelectedCourse(section);
        });

      return entryTemplate;
    }
  }
);
